<template>
  <div class="table-custom-menu-box">
    <Menu
      class="air-table-headers-menu"
      :close-on-click="true"
      :close-on-content-click="false"
      :max-height="300"
      attach="#table-custom-menu"
    >
      <template v-slot:menu-btn="{ on, attrs }">
        <v-toolbar-title
          v-on="on"
          class="header-update-btn"
          :class="attrs['aria-expanded'] !== 'false' ? 'header-update-btn-active' : ''"
        >
          <FIcon name="cancel" size="2.3rem" :color="'#06c1ed'" class="open-list btn-icon-close" />
          <FIcon name="increase" size="2.3rem" :color="'#949fa5'" class="open-list icon-open" />
        </v-toolbar-title>
      </template>

      <template #menu-list>
        <v-list>
          <v-list-item
            v-for="(column, cIndex) in columns"
            :key="`header-column-key-${cIndex}`"
            :id="`table_custom_columns_menu_item_${cIndex}`"
            v-if="!column.unRemovable"
          >
            <v-list-item-title>
              <v-checkbox
                :ripple="false"
                :value="column.selected"
                :id="`column_${column.value}`"
                :disabled="column.selected && isDisabled"
                :label="column.text"
                hide-details
                v-model="column.selected"
                class="header-column-name"
              />
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </template>
    </Menu>
    <div id="table-custom-menu" class="attach-table-custom-menu" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    isLoading: true,
  }),

  computed: {
    ...mapGetters({
      filter: "App/filter",
    }),

    /***
     * Get Columns
     * @return {Array<FilterColumnInterface>}
     */
    columns() {
      return this.filter?.columns;
    },

    /***
     * Is Disabled
     * @return {Boolean}
     */
    isDisabled() {
      return this.filter.countSelectedColumns() < 3;
    },
  },

  watch: {
    "filter.columns": {
      immediate: true,
      deep: true,

      handler() {
        if (!this.filter || this.isLoading) return;
        this.filter.storeColumns();
      },
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.attach-table-custom-menu {
  ::v-deep {
    position: relative;
    .v-menu__content {
      position: absolute !important;
      left: auto !important;
      right: 0 !important;
      margin-top: 1rem;
    }
  }
}
</style>
